export default __webpack_public_path__ + "static/media/icone-xml.12bf5a6d.svg";